<template>
  <div class="shopDetail" :style="shopDetailStyle">
      <div v-if="content.showTime">
        <p class="title" :style="titleStyle">营业时间</p>
        <p class="text" :style="textStyle">{{ content.timeText || '--' }}</p>
      </div>
      <div v-if="content.showPhone" class="phone">
        <p class="title" :style="titleStyle">服务电话</p>
        <p class="text" :style="textStyle">010-8888888</p>
      </div>
      <div v-if="content.showAddress" class="address">
        <p class="title" :style="titleStyle">门店地址</p>
        <p class="text" :style="textStyle">北京市朝阳区朝阳公园</p>
      </div>
  </div>
</template>

<script>

import mixins from '../mixins/mixins'
export default {
  name: 'shopDetail',
  props: {},
  components: {},
  mixins: [mixins],
  data() {
    return {
      detailData: {
        list: []
      },
      pattern: {},
      content: {},
    }
  },
  watch: {
  },
  computed: {
    shopDetailStyle(){
      return {
        "margin-left": (this.pattern.margin || 0) + 'px',
        "margin-right": (this.pattern.margin || 0) + 'px',
        "background-color":this.pattern.bgColor
      }
    },
    textStyle(){
      return {
        "color":this.pattern.textColor
      }
    },
    titleStyle(){
      return {
        "color":this.pattern.titleColor
      }
    }
  },
  methods: {
    async init() {
      this.detailData = await this._filter(this.itemData)
      this.pattern = this.detailData.pattern || {}
      this.content = this.detailData.content || {}
      console.log("shopDetail----------this.detailData");
      console.log(this.detailData);
    },
  },
  async mounted() {
    
  }
}
</script>
<style lang="scss" scoped>
.shopDetail{
  padding: 10px 25px 38px;
  &>div{
    margin-bottom: 11px;
    position: relative;
    .title{
      font-size: 10px;
      color: #999999;
      line-height: 20px;
    }
    .text{
      font-weight: 400;
      font-size: 12px;
      color: #000000;
      line-height: 20px;
    }
    &.address{
      background-image: url("../image/address.png");
    }
    &.phone{
      background-image: url("../image/phone.png");
    }
    &.address,
    &.phone{
      background-repeat: no-repeat;
      background-size: 24px 24px;
      background-position: 100% 7px;
    }
    img{
      position: absolute;
      right: 0;
      top: 7px;
      width: 24px;
      height: 24px;
      border-radius: 50%;
    }
  }
}
</style>
